import { render, staticRenderFns } from "./ekko.home.vue?vue&type=template&id=1e52d6a4&scoped=true&"
import script from "./ekko.home.vue?vue&type=script&lang=ts&"
export * from "./ekko.home.vue?vue&type=script&lang=ts&"
import style0 from "./ekko.home.vue?vue&type=style&index=0&id=1e52d6a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e52d6a4",
  null
  
)

export default component.exports